<template>
  <FileUpload
  :limitSizeOfMB="limitSizeOfMB"
  :compressToMB="compressToMB"
  :acceptExtensions="fileExtensionsLimit"
  :fileQuantityLimit="fileQuantityLimit"
  :pictureSizeRemark="pictureSizeRemark"
  listType="picture"
  :fileList.sync="fileListTemp">
  </FileUpload>
</template>

<script>

import FileUpload from '@/components/FileUpload.vue';

export default {
  data() {
    return {
      fileListTemp: [],
      fileExtensionsLimit: [
        '.jpg',
        '.jpeg',
        '.png',
        '.gif',
      ],
    };
  },
  props: {
    fileList: Array,
    fileQuantityLimit: Number,
    pictureSizeRemark: String,
    limitSizeOfMB: { // 單一檔案大小限制
      type: Number,
      default: 5,
    },
    compressToMB: Number, // 超過此大小自動壓縮，不傳則不壓縮
  },
  methods: {
  },
  computed: {
  },
  mounted() {
    // 一開始prop傳進來不會觸發watch 手動初始化
    this.fileListTemp = this.fileList;
  },
  components: {
    FileUpload,
  },
  watch: {
    fileListTemp() {
      this.$emit('update:fileList', this.fileListTemp);
    },
    fileList() {
      this.fileListTemp = this.fileList;
    },
  },
};
</script>
